<template>
  <div class="container">
    <!-- <div class="nav">
      <img class="bkIMg" :src='backImg' alt="">
      <img class="nav_anut" :src='auntImg' alt="">
      <img class="nav_kc4" :src='kc4Img' alt="">
      <img class="nav_kc3" :src='kc3Img' alt="">
      <h5 class="title">所有活动</h5>
    </div>     -->
    <div class="content">
      <div class="content_item" v-for="(item ,index) in List" :key="index">
        <!-- <img class="badge_img" :src='kc7Img' alt=""> -->
        <img class="content_img" :src='item.img_url' alt="">
        <div class="column">
          <div class="mid_title">{{item.title}}</div>
          <div class="rower">
            <div class="content_mid">
              <div class="mid_text">{{item.desc}}</div>
            </div>
            <div class="content_right">
              <div class="content_right_btn" @click="todetail(item)">查看详情</div>
            </div>
          </div>
        </div>
        
      </div>
      
      
     
    </div>

    <div class="empty" v-if="List.length==0">
      <img class="pic" :src="emptyImg">
      <div class="pro">暂无更多活动</div>
    </div>

  </div>
</template>
<style lang="stylus" rel="stylesheet/stylus" scoped>
$rem = 100;
.column{
  display: flex;
  flex-direction: column;
  padding-left: 12px;
  box-sizing: border-box;
  width: calc(100% - 120px) ;
}
.rower{
  display: flex;
  flex-direction: row;
  height :60px;
}
.empty{
  margin-top: 0px;
  width:100%;
  height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(255,255,255);
  padding-top:42px;
  flex-direction: column;
}
.pic{
  width:120px;
  height:120px;
}
.pro{
  color: rgb(34,34,34);
  font-size: 14px;
  margin-top: 20px;
}

.container{
  overflow-y: scroll;
  // font-family:Helvetica, Tahoma, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei";
  color: rgb(34,34,34);
}
.badge_img{
   width: 55px;
  height: 55px;
  position: absolute;
    right: -3px;
    top: -3px;
}
.nav{
  width: 100%;
  position: relative;
  background-color: #fff;
  height: 220px;
}
.title{
    display: flex;
    /* -webkit-box-align: center; */
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 600;
    color: #31285d;
    padding: 50px 0 0px 0;
    background: radial-gradient(circle,#48f4cb 0,#48f4cb 10px,transparent 0,transparent 100%) calc(50% - 34px) 20px,radial-gradient(circle,#fdc82f 0,#fdc82f 6px,transparent 0,transparent 100%) calc(50% + 38px) 28px;
    background-repeat: no-repeat;
    position: relative;
    bottom: 68px;
}
.title::before{
    content: "";
    display: block;
    width: 10px;
    height: 2px;
    border-radius: 2px;
    margin-right: 5px;
    background-color: #31285d;
}
.title::after{
    content: "";
    display: block;
    width:10px;
    height: 2px;
    border-radius: 2px;
    margin-left: 5px;
    background-color: #31285d;
}
.nav_anut{
  position: absolute;
  width: 130px;
  left: 5px;
  top: 0px;
}
.nav_kc4{
  width: 240px;
  top: 44px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.nav_kc3{
    position: absolute;
    width: 65px;
    top: 112px;
    left: 50%;
    transform: translateX(-50%);
}
.bkIMg{
  width: 100%;
  height: 180px;
}
.tit{
  font-size: 16px;
  margin-top: 12px;
  padding-left: 15px;
  font-weight: 600;
}
.content{
  width: 100%;
  margin-bottom :50px
}
.content_item{
  width: calc(100% - 20px);
  margin-left: 10px;
  height: 90px;
  background-color: #fff;
  border-radius: 10px;
  margin-top: 15px;
  position: relative;
  display: flex;
  flex-direction: row;
}
.content_img{
  width: 150px;
  height: 100%;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  flex: 7;
}
.content_mid{
  // margin-left: 12px;
  flex: 8;
  align-items: center;
    display: flex;
}
.content_right{
  flex: 5;
  display :flex;
  flex-direction :column;
  align-items: center;
  justify-content :flex-end;
}
.mid_title{
  font-weight: 600;
  font-size: 14px;
  color: rgb(34,34,34);
  margin-top :5px;
  margin-bottom 5px;
  line-height: 24px;
 text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp:1;
  -webkit-box-orient: vertical;
}
.mid_text{
  font-size: 12px;
  color:#1b1243; 
  line-height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.content_right_btn{
  width:  (200 / $rem) rem;
    height: 25px;
    text-align: center;
    line-height: 25px;
    background-color: #B3212D;
    color: #fff;
    border-radius: 24px;
    font-size: 12px;
    margin-bottom 5px;
    margin-top :5px
}
.content_right_num{
  display :flex;
  flex-direction :row;
  justify-content :center;
  align-items :center
}
.content_right_num_icon{
  width :12px;
  height :12px;
  margin-right :2px;
}
.content_right_num_text{
  font-size 12px;
  color #879AA7;
  margin-top :1px;
}

</style>

<script>
import {getActivityList} from '../apollo/apollo'
export default {
   components: {
    
  },
  data() {
    return {
      backImg:'./static/imgs/kc2.png',
      auntImg:'./static/imgs/kc1.png',
      kc4Img:'./static/imgs/kc4.png',
      kc3Img:'./static/imgs/kc3.png',
      kc7Img:'./static/imgs/kc7.png',
      emptyImg:'./static/imgs/empty@2x.png',
      List:[],//活动列表

    }
  },
  computed:{
    
  },
  created() {
    this.init()
  },
  methods: {
    todetail(item){
      this.$store.state.isactive='1'
      sessionStorage.setItem('activity_id',item.id);
      // this.$store.state.activity_id=item.id
      this.jump('./active')
    },
    init(){
      getActivityList().then(res=>{
        this.List=res.data.getActivityList
        })
        .catch(err=>{
          this.msgManage(err)
        })
    },

    


  }, 

  watch:{
    
  }
};
</script>


// WEBPACK FOOTER //
// src/views/activeList.vue